import { SubjectLevel } from './../../resource/subject/subject.model';

const getFormByLevel = (level: string, delimeter = ' '): number | null => {
  //NOTE: To handle for chapter that does nat has from (only by elementary, lowerform or upperform)
  // if (level === SubjectLevel.Elementary) {
  //   return -1;
  // }
  if (level === SubjectLevel.LowerForm) {
    return -2;
  }
  if (level === SubjectLevel.UpperForm) {
    return -3;
  }

  const formArray = level.split(delimeter);

  const number = parseInt(formArray[1].trim());

  if (isNaN(number)) {
    return null;
  }

  if (formArray[0].toLowerCase() === 'year') {
    return number;
  } else if (formArray[0].toLowerCase() === 'form') {
    return number + 6;
  } else {
    return null;
  }
};

export default getFormByLevel;
